import styled from '@emotion/styled';

export default styled.div`
  display: flex;
  font-size: 0.9rem;
  padding: .2rem 0;
  justify-content: space-between;
`;
